module.exports = __webpack_public_path__ + "img/iwaki_mail.3d82e71b.png";